module.exports = __webpack_public_path__ + "img/plant1.db95081f.png";